let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gRuwt")).then(() => parcelRequire('7c5Kl'));